import { render, staticRenderFns } from "./DrugInfoStatsList.vue?vue&type=template&id=24333ac2&"
import script from "./DrugInfoStatsList.vue?vue&type=script&lang=js&"
export * from "./DrugInfoStatsList.vue?vue&type=script&lang=js&"
import style0 from "./DrugInfoStatsList.vue?vue&type=style&index=0&id=24333ac2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24333ac2')) {
      api.createRecord('24333ac2', component.options)
    } else {
      api.reload('24333ac2', component.options)
    }
    module.hot.accept("./DrugInfoStatsList.vue?vue&type=template&id=24333ac2&", function () {
      api.rerender('24333ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/statistics/durginfo-stast-view/DrugInfoStatsList.vue"
export default component.exports